import { useTranslation } from 'react-i18next';
import { FilterPopover } from 'src/components/molecules/filter-popover';
import { issueStateColors } from 'src/features/issues/constants/issue-state/issue-state-colors';
import { issueStateFilterValues } from 'src/features/issues/constants/issue-state/issue-state-filter-values';
import { issueStateTranslations } from 'src/features/issues/constants/issue-state/issue-state-translations';
import { IssueState } from 'src/features/issues/types/issue-state';
import { HandleChangeFilterValue } from 'src/types/handle-change-filter-value';
import { FilterGroup } from 'src/types/interfaces/filter-group';
import { Filters } from 'src/types/interfaces/filters';
import { getSelectedFilters } from 'src/utils/filters/get-selected-filters';
import { toggleFilterItemSelection } from 'src/utils/filters/toggle-filter-item-selection';

interface Props {
  filters: Filters;
  handleChangeFilterValue: HandleChangeFilterValue;
}

export const IssueStateFilterPopover = ({
  filters,
  handleChangeFilterValue,
}: Props) => {
  const { t } = useTranslation(['issues']);

  const filterGroup: FilterGroup<IssueState | string> = {
    id: 1,
    type: 'status',
    label: t('issues:common.state.title'),
    singleOption: true,
    filterOperator: 'custom',
    items: [
      {
        label: t(issueStateTranslations.NEW),
        value: issueStateFilterValues.NEW,
        color: issueStateColors.NEW,
      },
      {
        label: t(issueStateTranslations.IN_PROGRESS),
        value: issueStateFilterValues.IN_PROGRESS,
        color: issueStateColors.IN_PROGRESS,
      },
      {
        label: t(issueStateTranslations.RESOLVED),
        value: issueStateFilterValues.RESOLVED,
        color: issueStateColors.RESOLVED,
      },
      {
        label: t(issueStateTranslations.REJECTED),
        value: issueStateFilterValues.REJECTED,
        color: issueStateColors.REJECTED,
      },
    ],
  };

  return (
    <FilterPopover
      title={filterGroup.label}
      withStatusBadge
      selected={getSelectedFilters(filters, filterGroup.type)}
      onChange={option => {
        toggleFilterItemSelection(
          filterGroup.type,
          option,
          filterGroup.singleOption,
          filters,
          handleChangeFilterValue,
          filterGroup.filterOperator,
        );
      }}
      options={filterGroup.items}
    />
  );
};
